namespace TabAurous.Retail {
    export interface ExchangeRow {
        TransId?: number;
        TransDate?: string;
        VoucherNo?: string;
        VoucherTypeId?: number;
        VoucherTypeName?: string;
        AutoPosting?: boolean;
        PartyId?: number;
        POSCustomerId?: number;
        FirstName?: string;
        LastName?: string;
        PosCustomerCode?: string;
        CustomerName?: string;
        PanNumber?: string;
        Email?: string;
        BirthDate?: string;
        Anniversary?: string;
        Address?: string;
        Mobile?: string;
        TermsId?: number;
        CurrencyId?: number;
        ExchRate?: number;
        NetAmount?: number;
        TaxAmount?: number;
        Discount?: number;
        AdditionalCharges?: number;
        RoundOff?: number;
        GrossAmount?: number;
        Remark?: string;
        CompanyId?: number;
        BillNo?: string;
        BillDate?: string;
        ChallanNo?: string;
        ChallanDate?: string;
        EmployeeId?: number;
        FinancialYearId?: number;
        ShipmentId?: number;
        ShipAddressId?: number;
        UserId?: number;
        ItemDetails?: ExchangeItemsRow[];
        Pieces?: number;
        Weight?: number;
        NetWeight?: number;
        IsExchanged?: boolean;
        ProductItemImage?: string;
        PostingDate?: string;
        IsPosted?: boolean;
        CCNetAmount?: number;
        CCTaxAmount?: number;
        CCGrossAmount?: number;
        CCRoundOff?: number;
        Username?: string;
    }

    export namespace ExchangeRow {
        export const idProperty = 'TransId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'Retail.Exchange';
        export const deletePermission = 'Retail:Exchange:Delete';
        export const insertPermission = 'Retail:Exchange:Add';
        export const readPermission = '*';
        export const updatePermission = 'Retail:Exchange:Edit';

        export declare const enum Fields {
            TransId = "TransId",
            TransDate = "TransDate",
            VoucherNo = "VoucherNo",
            VoucherTypeId = "VoucherTypeId",
            VoucherTypeName = "VoucherTypeName",
            AutoPosting = "AutoPosting",
            PartyId = "PartyId",
            POSCustomerId = "POSCustomerId",
            FirstName = "FirstName",
            LastName = "LastName",
            PosCustomerCode = "PosCustomerCode",
            CustomerName = "CustomerName",
            PanNumber = "PanNumber",
            Email = "Email",
            BirthDate = "BirthDate",
            Anniversary = "Anniversary",
            Address = "Address",
            Mobile = "Mobile",
            TermsId = "TermsId",
            CurrencyId = "CurrencyId",
            ExchRate = "ExchRate",
            NetAmount = "NetAmount",
            TaxAmount = "TaxAmount",
            Discount = "Discount",
            AdditionalCharges = "AdditionalCharges",
            RoundOff = "RoundOff",
            GrossAmount = "GrossAmount",
            Remark = "Remark",
            CompanyId = "CompanyId",
            BillNo = "BillNo",
            BillDate = "BillDate",
            ChallanNo = "ChallanNo",
            ChallanDate = "ChallanDate",
            EmployeeId = "EmployeeId",
            FinancialYearId = "FinancialYearId",
            ShipmentId = "ShipmentId",
            ShipAddressId = "ShipAddressId",
            UserId = "UserId",
            ItemDetails = "ItemDetails",
            Pieces = "Pieces",
            Weight = "Weight",
            NetWeight = "NetWeight",
            IsExchanged = "IsExchanged",
            ProductItemImage = "ProductItemImage",
            PostingDate = "PostingDate",
            IsPosted = "IsPosted",
            CCNetAmount = "CCNetAmount",
            CCTaxAmount = "CCTaxAmount",
            CCGrossAmount = "CCGrossAmount",
            CCRoundOff = "CCRoundOff",
            Username = "Username"
        }
    }
}
